const numberInputs = document.querySelectorAll('.input-spinner-wrapper');

numberInputs.forEach(wrapper => {
    const buttons = wrapper.querySelectorAll('[data-input-number]');
    buttons.forEach(button => {
        button.inputTarget = document.getElementById(button.dataset.target);
        button.addEventListener('click', () => {
            const currentValue = parseNumber(button.inputTarget.value);
            if (button.dataset.inputNumber === 'increase') {
                if (typeof button.inputTarget.getAttribute('data-max') === undefined || (parseNumber(button.inputTarget.getAttribute('data-max')) >= currentValue + 1)) {
                    button.inputTarget.value = currentValue + 1;
                }else{
					button.inputTarget.value = button.inputTarget.getAttribute('data-max');
				}
            }
            if (button.dataset.inputNumber === 'decrease') {
                if (typeof button.inputTarget.getAttribute('data-min') === undefined || (parseNumber(button.inputTarget.getAttribute('data-min')) <= currentValue - 1)) {
                    button.inputTarget.value = currentValue - 1;
                }else{
					button.inputTarget.value = button.inputTarget.getAttribute('data-min');
				}
            }
        })
    });

    const input = wrapper.querySelector('.input-spinner');
    input.addEventListener('input', (e) => {
        if (e.target.value !== '') {
            const value = parseNumber(e.target.value)
            if (typeof e.target.getAttribute('data-min') !== undefined && (parseNumber(e.target.getAttribute('data-min')) > value)) {
                e.target.value = e.target.getAttribute('data-min');
            }
            if (typeof e.target.getAttribute('data-max') !== undefined && ( parseNumber(e.target.getAttribute('data-max')) < value)) {
            	e.target.value = e.target.getAttribute('data-max');
            }
        }
    })
})

function parseNumber(value) {
    let parsed = parseInt(value, 10)
    if (isNaN(parsed)) {
        return 0;
    }
    return parsed;
}